import { gql } from "@apollo/client";

export const baseQuery = gql`
  query base($id: ID!) {
    base {
      user(id: $id) {
        id
        name
        preferences {
          theme
          locale
          cubeContext {
            workspaceId
            scenarioId
            originId
            __typename
          }
          __typename
        }
        abilities {
          can_assign_intervals
          can_assign_blocks
          can_assign_instructors
          can_assign_classrooms
          can_edit_links_and_sections
          instructor_scheduled_hours
          can_edit_assignment
          can_access_group_manager
          can_edit_or_delete_sessions
          can_edit_packages
          can_edit_past_sessions
          can_delete_sections
          can_delete_packages
          can_assign_instructors_from_other_courses
          can_create_groups_in_bundle_view
          can_delete_groups_in_bundle_view
          can_edit_groups_in_bundle_view
          can_migrate_groups_in_bundle_view
          can_create_sub_groups_in_group_manager
          can_edit_groups_in_group_manager
          can_delete_sessions_in_holidays
          can_unassign_intervals
          can_edit_bookings
          can_edit_retaker_capacities
          can_edit_programming
          can_edit_programming_for_started_links
          can_skip_programming_stage_completeness_validation
          can_skip_programming_stage_dependencies_validation
          can_skip_unscheduled_programming_stage_validation
          __typename
        }
        permissions {
          read
          update
          create
          delete
          __typename
        }
        context {
          workspaceId
          scenarioId
          originId
          __typename
        }
        __typename
      }
      modules {
        code
        url
        accesible(userId: $id)
        __typename
      }
      catalogs {
        id
        path
        label
        accesible(userId: $id)
        __typename
      }
      reports {
        id
        path
        label
        accesible(userId: $id)
        __typename
      }
      productConfigurations {
        id
        path
        label
        accesible(userId: $id)
        permissions(userId: $id) {
          read
          update
          create
          delete
          import
          __typename
        }
        __typename
      }
      scenarioConfigurations {
        id
        path
        label
        accesible(userId: $id)
        permissions(userId: $id) {
          read
          update
          create
          delete
          import
          __typename
        }
        __typename
      }
      forecasts {
        id
        path
        label
        accesible(userId: $id)
        __typename
      }
      assignations {
        id
        path
        label
        accesible(userId: $id)
        __typename
      }
      userConfigurations {
        id
        path
        label
        accesible(userId: $id)
        __typename
      }
      onOff {
        groupText
        __typename
      }
      customUrls {
        code
        url
        __typename
      }
      __typename
    }
  }
`;
